module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_6.f3e1e97c.png";